import { style } from "@vanilla-extract/css";
import { recipe } from "@vanilla-extract/recipes";
import { rem } from "@huub-web/utils/css/rem";

import { zIndexes } from "../../theme/zIndex";
import { responsive } from "../../utils/responsive";
import { theme } from "../../theme/css/theme.css";

const HEADER_HEIGHT = 64;
const HEADER_BREAKPOINT = 860;
const MOBILE_SELECT_BREAKPOINT = 1000;

/**
 * Mobile select - visible on small screens, hidden on large screens
 */
export const mobileSelectStyle = style({
  display: "block",
  width: "100%",
  maxWidth: rem(280),
  margin: "0 auto",
  padding: `${theme.spacings.xs} ${theme.spacings.m}`,
  ...responsive({
    [MOBILE_SELECT_BREAKPOINT]: {
      display: "none",
    },
  }),
});

/**
 * Desktop menu items - hidden on small screens, visible on large screens
 */
export const desktopMenuStyle = style({
  display: "none",
  ...responsive({
    [MOBILE_SELECT_BREAKPOINT]: {
      display: "flex",
    },
  }),
});

export const containerStyle = recipe({
  base: {
    position: "sticky",
    zIndex: zIndexes.navigation,
    overflow: "visible",
    background: `var(--default-background, ${theme.colors.background})`,
    borderRadius: theme.borderRadiuses.s,
  },
  variants: {
    variant: {
      marketing: {
        top: `calc(${rem(HEADER_HEIGHT)} + ${theme.spacings.xs})`,
      },
      app: {
        top: 0,
        ...responsive({
          [HEADER_BREAKPOINT]: {
            top: rem(8),
          },
        }),
      },
      carousel: {
        position: "relative",
        top: "unset",
      },
    },
  },
  defaultVariants: {
    variant: "marketing",
  },
});

export const menuStyle = style({
  padding: `${theme.spacings.xs} ${theme.spacings.m} ${rem(1)}`,
  gap: `0 ${theme.spacings.xs}`,
  minHeight: rem(48),
  overflow: "hidden",
  position: "relative",
  zIndex: 4,
});

export const carouselMenuStyle = style({
  paddingBottom: theme.spacings.xs,
});
